import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
    template: require('./crew-error-dialog.component.html')
})
export class CrewErrorDialog {
    constructor(public dialogRef: MatDialogRef<CrewErrorDialog>) {
        this.title = "";
        this.contentStart = "";
        this.mainContent = "";
        this.okText = "OK";
    }

    title: string;

    contentStart: string;

    mainContent: string;

    okText: string;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/crew-error-dialog.component.ts